import {useState} from "react";
import ButtonCardHeader from "../../../../../components/Button/ButtonCardHeader";
import CustomDialog from "../../../../../components/Dialog/DiaCompMedium";
//import PathoTextInfo from "./PathoTextInfo";

export default function DiaHeaderMicro() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      

<ButtonCardHeader name="GUT MICROBIOME" action={handleOpen} />

<CustomDialog open={open} onClose={handleClose}

    title="Summary Microbiome Analysis"
    content = {" "}
/>

</>
)}